export const EXTENSIONS = [
  { value: "mp3", title: "MP3" },
  { value: "ogg", title: "OGG" },
];
